<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <h2 class="title-h2 mb-6">Порядок выкупа автомобиля</h2>
      <div class="overflow-hidden">
        <div class="-mb-8 overflow-x-auto">
          <div class="pb-8 flex min-w-[737px]">
            <div class="w-1/4" v-for="(item, index) in list" :key="index">
              <div class="flex items-center justify-center w-16 h-16 rounded-brand bg-white mb-2">
                <svg class="w-[40px] min-w-[40px] h-[40px] mb-1">
                  <use :xlink:href="'/public/images/svg/sprite.svg' + (item.url ? item.url : '#order1')"></use>
                </svg>
              </div>
              <p class="font-medium leading-8 mb-2 text-gray-700" v-html="item.title"></p>
              <div class="relative w-full mb-2">
                <div class="absolute top-3 w-full border-t border-b-2 border-gray-light"></div>
                <div class="relative z-1 w-6 h-6 rounded-full bg-green"></div>
              </div>
              <p class="max-w-[180px] text-sm pr-4 text-gray-600" v-html="item.text"></p>
            </div>
            <div>
              <div class="flex items-center justify-center w-16 h-16 mb-2"></div>
              <p class="font-medium leading-8 mb-2">&nbsp;</p>
              <div class="relative w-full mb-2">
                <div class="relative z-1 w-6 h-6 rounded-full bg-green"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  components: {},
  data() {
    return {
      list: [
        {
          title: 'Заявка',
          text: 'Вы&nbsp;оставляете заявку: заполняете форму на&nbsp;сайте/звоните/пишите в мессенджер',
          url: '#order1',
        },
        {
          title: 'Звонок',
          text: 'Мы связываемся с&nbsp;вами, проводим оценку и диагностику (на территории ДЦ, либо выездной выкуп)',
          url: '#order2',
        },
        {
          title: 'Документы',
          text: 'Мы&nbsp;оформляем все необходимые документы за&nbsp;Вас',
          url: '#order3',
        },
        {
          title: 'Оплата',
          text: 'Вы&nbsp;получаете деньги сразу после оформления договора купли-продажи',
          url: '#order4',
        },
      ],
    };
  },
};
</script>
